// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"145":"a64f608a","291":"cdda351c"}[chunkId] + ".css";
};